import React, { useState, useRef } from 'react'
import { useQuery, useMutation } from 'react-apollo'
import gql from 'graphql-tag'
import { useSelector } from 'react-redux'

import { DRF } from 'types/drf';
import { ReduxState } from 'types/redux'
import { useGlobalContext } from 'components/context'
import * as commonStyle from '../common.module.sass'
import { getPublicForms, getPublicFormsVariables } from './gql-types/getPublicForms'
import Placeholder from 'components/common/placeholder'
import ExternalLink, { EXTERNAL_LINK_FRAGMENT } from './external-link'
import { createPublicForm, createPublicFormVariables} from './gql-types/createPublicForm'
import { FormProps } from 'components/form/hooks/form-context';


type Props = {
	readOnly: boolean
	formProps: FormProps
}

const GET_PUBLIC_FORMS = gql`
	query getPublicForms($record: ID!, $form: ID!) {
		publicForm_List(record: $record, form: $form) {
			objects {
				...ExternalLink
			}
		}
	}
	${EXTERNAL_LINK_FRAGMENT}
`

const CREATE_PUBLIC_FORM = gql`
	mutation createPublicForm($record: ID!, $form: ID!) {
		publicForm_Update(input: {record: $record, form: $form}) {
			object {
				...ExternalLink
			}
		}
	}
	${EXTERNAL_LINK_FRAGMENT}
`

const CreatePublicForm = ({ readOnly, formProps }: Props) => {
	const variables = { variables: { record: formProps.record.id, form: formProps.form.id }}
	const { data, loading, refetch } = useQuery<getPublicForms, getPublicFormsVariables>(GET_PUBLIC_FORMS, variables)
	const [createPublicForm, { loading: mutationLoading }] = useMutation<createPublicForm, createPublicFormVariables>(CREATE_PUBLIC_FORM)

	const objects = data?.publicForm_List?.objects

	if (loading || mutationLoading) {
		return <Placeholder />
	} else if (objects === undefined) {
		return <div className="error">error</div>
	}

	if(readOnly) return (
		<div className="public-link-container">
			<div className="muted">Share links deactivated when archived</div>
		</div>
	)

	const externalLinks = objects.filter(externalLink => externalLink.active)

	return ( 
		formProps.form.allowPublicLinks ?
			<div>
				<div className={commonStyle.sectionTitle}>
					Share
					{formProps.form.publicLinkIsReadOnly && <span className="muted">: read only</span>}
				</div>

				{ externalLinks && externalLinks.length == 0 &&
					<button
						className="icon-world button-grey-solid"
						onClick={() => {
							createPublicForm(variables).then(r => {
								refetch()
							})
						}}
					>
						Create link
					</button>
				}

				{ externalLinks.map( externalLink => (
					<ExternalLink
						key={externalLink.id}
						externalLink={externalLink}
						formProps={formProps}
					/>
				))}
			</div>
		:
			<div/>
	)
}


export default CreatePublicForm